import React, { useState, useEffect } from "react";
import axiosInstance from "../../Axios/axiosInstance";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Divider,
  Box,
  Snackbar,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import EditIcon from "@mui/icons-material/Edit";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const FitnessUpdate = () => {
  const { itemId } = useParams();
  const [formData, setFormData] = useState({
    ownername: "",
    guardianname: "",
    vehicleno: "",
    engineno: "",
    chassisno: "",
    startdate: null,
    expiredate: null,
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [datas, setData] = useState({});
  const [adhardocument, setAdhardocument] = useState(null);
  const [pan, setPan] = useState(null);
  const [Rc, setRc] = useState(null);
  const [other, setOther] = useState(null);
  const [fitness, setFitness] = useState(null);
  const loadfitness = async () => {
      const res = await axiosInstance.get(`/api/getfitnessdoc/${itemId}`, {
      });
      setData(res.data.client);
     
    };
    console.log(datas);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChangeAdhar = (event) => {
    const selectedFiles = event.target.files[0];
    if (selectedFiles) {
      // Set the file in the state
      setAdhardocument(selectedFiles);
      handleInputChange({
      target: {
        name: "adhardocument",
        value: selectedFiles,
        size: selectedFiles.size,
      },
    });
  }
  };
  const handleFileChangePan = (event) => {
    const selectedFiles = event.target.files[0];
    if (selectedFiles) {
      // Set the file in the state
      setPan(selectedFiles);
      handleInputChange({
      target: {
        name: "pandocument",
        value: selectedFiles,
        size: selectedFiles.size,
      },
    });
  }
  };
  const handleFileChangeRc = (event) => {
    const selectedFiles = event.target.files[0];
    if (selectedFiles) {
      // Set the file in the state
      setRc(selectedFiles);
    handleInputChange({
      target: {
        name: "rcdocument",
        value: selectedFiles,
        size: selectedFiles.size,
      },
    });
  }
  };
  const handleFileChangeOther = (event) => {
    const selectedFiles = event.target.files[0];
    if (selectedFiles) {
      // Set the file in the state
      setOther(selectedFiles);
    handleInputChange({
      target: {
        name: "otherdocument",
        value: selectedFiles,
        size: selectedFiles.size,
      },
    });
  }
  };
  const handleFileChangeFitness = (event) => {
    const selectedFiles = event.target.files[0];
    if (selectedFiles) {
      // Set the file in the state
      setFitness(selectedFiles);
      handleInputChange({
      target: {
        name: "fitnessdocument",
        value: selectedFiles,
        size: selectedFiles.size,
      },
    });
  }
  };

  const handlestartDateChange = (date) => {
    let formattedstartDate = null;

    if (date) {
      formattedstartDate = dayjs(date).isValid()
        ? dayjs(date).toISOString()
        : null;
    }

    setFormData({
      ...formData,
      startdate: formattedstartDate,
    });
  };

  const handleexpireDateChange = (date) => {
    let formattedexpireDate = null;

    if (date) {
      formattedexpireDate = dayjs(date).isValid()
        ? dayjs(date).toISOString()
        : null;
    }

    setFormData({
      ...formData,
      expiredate: formattedexpireDate,
    });
  };

  const handleSuccessClose = () => {
    setOpenSuccess(false);
  };

  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const response = await axiosInstance.get(`/api/getFitness/${itemId}`);
        if (response.status === 200) {
          const clientData = response.data.client;
          setFormData({
            // Update formData with clientData received
            ...clientData,
            registrationdate: clientData.registrationdate
              ? dayjs(clientData.registrationdate).toDate()
              : null,
            startdate: clientData.startdate
              ? dayjs(clientData.startdate).toDate()
              : null,
            expiredate: clientData.expiredate
              ? dayjs(clientData.expiredate).toDate()
              : null,
            insurencedocument: clientData.insurencedocument || "",
          });
        }
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    };

    if (itemId) {
      // Ensure itemId exists before fetching data
      fetchClientData();
      loadfitness();
    }
  }, [itemId]);

  const handleEditClick = () => {
    setIsEditMode(true); // Enable edit mode
    setIsSubmitting(false); // Reset submission status on edit click
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const formDataToSend = new FormData();
      
      formDataToSend.append("formData", JSON.stringify(formData));
      console.log(JSON.stringify(formData))
      formDataToSend.append("pandocument", pan);
      formDataToSend.append("adhardocument", adhardocument);
      formDataToSend.append("rcdocument", Rc);
      formDataToSend.append("otherdocument", other);
      formDataToSend.append("fitnessdocument", fitness);
      const response = await axiosInstance.put(
        `/api/updateFitness/${itemId}`,
        formDataToSend
      );
      if (response.status === 200) {
        setSuccessMessage("Client Fitness updated successfully");
        setOpenSuccess(true);
        setIsEditMode(false);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error updating client fitness data:", error.response.data);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <form onSubmit={handleUpdate}>
        <Grid container spacing={3}>
          {/* Employee Registration Heading */}
          <Grid container item xs={12}>
            <Grid item xs={8}>
              <Typography variant="h5" align="left">
                Client Details
              </Typography>
            </Grid>
            <Grid item xs={4} className="text-end">
              <EditIcon
                style={{
                  cursor: "pointer",
                }}
                onClick={handleEditClick}
              />
            </Grid>
          </Grid>

          {/* User Details */}
          <Grid container item>
            <Grid item className="mt-1">
              <Typography variant="h6" align="left">
                Service Types
              </Typography>
            </Grid>
            <Grid item className="ms-4">
              <Typography
                variant="h6"
                align="left"
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #000",
                  borderRadius: "4px",
                  padding: "5px",
                }}
              >
                Fitness 
                {/* <ArrowDropDownIcon /> */}
              </Typography>
            </Grid>
          </Grid>

          {/* Divider line */}
          <Grid item xs={12}>
            <Box>
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "black" }}
              />
            </Box>
          </Grid>

          {/* -----------input fields---------------------------------------- */}
          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Owner Name</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="ownername"
                  value={formData.ownername}
                  onChange={handleInputChange}
                  size="small"
                  disabled={!isEditMode || isSubmitting}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Guardian Name</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="guardianname"
                  value={formData.guardianname}
                  onChange={handleInputChange}
                  size="small"
                  disabled={!isEditMode || isSubmitting}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Vehicle Number</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="vehicleno"
                  value={formData.vehicleno}
                  onChange={handleInputChange}
                  size="small"
                  disabled={!isEditMode || isSubmitting}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Engine Number</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="engineno"
                  value={formData.engineno}
                  onChange={handleInputChange}
                  size="small"
                  disabled={!isEditMode || isSubmitting}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Chassis Number</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="chassisno"
                  value={formData.chassisno}
                  onChange={handleInputChange}
                  size="small"
                  disabled={!isEditMode || isSubmitting}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* start Date */}
          <Grid item xs={12} lg={6} md={6} sm={12} className="">
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Start Date</Typography>
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={
                      formData.startdate ? dayjs(formData.startdate) : null
                    }
                    onChange={handlestartDateChange}
                    renderInput={(params) => <TextField {...params} />}
                    disabled={!isEditMode || isSubmitting}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
          {/* Expire Date */}
          <Grid item xs={12} lg={6} md={6} sm={12} className="">
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Expire Date</Typography>
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={
                      formData.expiredate ? dayjs(formData.expiredate) : null
                    }
                    onChange={handleexpireDateChange}
                    renderInput={(params) => <TextField {...params} />}
                    disabled={!isEditMode || isSubmitting}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Pancard</Typography>
              </Grid>
              <Grid item xs={6}>
              <input
                      type="file"
                      accept=".pdf"
                      name="pandocument"
                      onChange={handleFileChangePan}
                      disabled={!isEditMode || isSubmitting}
                    />
              <a href={`${axiosInstance.defaults.baseURL}api/uploadimage/pancard/${datas.pancard}`} target="_blank" rel="noopener noreferrer">
                <span>{datas.pancard}</span>
                </a>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Aadhar</Typography>
              </Grid>
              <Grid item xs={6}>
              <input
                      type="file"
                      accept=".pdf"
                      name="adhardocument"
                      onChange={handleFileChangeAdhar}
                      disabled={!isEditMode || isSubmitting}
                    />
              <a href={`${axiosInstance.defaults.baseURL}api/uploadimage/adharcard/${datas.adharcard}`} target="_blank" rel="noopener noreferrer">
                <span>{datas.adharcard}</span>
                </a>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Rc Card</Typography>
              </Grid>
              <Grid item xs={6}>
              <input
                      type="file"
                      accept=".pdf"
                      name="rcdocument"
                      onChange={handleFileChangeRc}
                      disabled={!isEditMode || isSubmitting}
                    />
              <a href={`${axiosInstance.defaults.baseURL}api/uploadimage/Rc/${datas.rc}`} target="_blank" rel="noopener noreferrer">
                <span>{datas.rc}</span>
                </a>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Fitness</Typography>
              </Grid>
              <Grid item xs={6}>
              <input
                      type="file"
                      accept=".pdf"
                      name="fitnessdocument"
                      onChange={handleFileChangeFitness}
                      disabled={!isEditMode || isSubmitting}
                    />
              <a href={`${axiosInstance.defaults.baseURL}api/uploadimage/fitness/${datas.fitness}`} target="_blank" rel="noopener noreferrer">
                <span>{datas.fitness}</span>
                </a>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className="text-center" lg={6} md={6} sm={12}>
            <Grid container alignItems="center">
              <Grid item xs={6} style={{ textAlign: "left" }}>
                <Typography variant="subtitle1">Other Document</Typography>
              </Grid>
              <Grid item xs={6}>
              <input
                      type="file"
                      accept=".pdf"
                      name="otherdocument"
                      onChange={handleFileChangeOther}
                      disabled={!isEditMode || isSubmitting}
                    />
              <a href={`${axiosInstance.defaults.baseURL}api/uploadimage/other/${datas.otherdocument}`} target="_blank" rel="noopener noreferrer">
                <span>{datas.otherdocument}</span>
                </a>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------- Submit Date ---------------------------------------- */}

          <Grid item xs={12} className="text-center mt-5">
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={!isEditMode || isSubmitting}
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </form>
      {/* Success Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSuccess}
        autoHideDuration={3000}
        onClose={handleSuccessClose}
        message={successMessage}
      />
    </>
  );
};

export default FitnessUpdate;
